import React from 'react'
import "../trinetra.css"
import { useNavigate } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../../assets/img/trinetra-final-logo.png'


export default function Welcome() {

    const navigate = useNavigate()
    const backButton = () => {
        // console.log ("button click");
        // navigate(-1);
      }
      
  return (
        <div className='row'>
        <div className='trinetra'>
            <h1>Welcome to <img src={logo} width={"16%"}/></h1>
            {/* <p>Supercharge your business with our AI product suite. TRINETRA™ enables you to automate, build and deliver exceptional results.</p> */}
        </div>
      </div>
  )
}
